import LoanPaymentService from "@/services/v2/bytepro/loanPayment.service";

export const loanPaymentApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getLoanPaymentsWithFilter(
      { commit },
      { loanNumber, pageNumber, pageSize, paidStatus }
    ) {
      return LoanPaymentService.getLoanPaymentsWithFilter(
        loanNumber,
        pageNumber,
        pageSize,
        paidStatus
      ).then(
        (resp) => {
          commit(
            "dummyConsole",
            "LoanPaymentService.getLoanPaymentsWithFilter - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "LoanPaymentService.getLoanPaymentsWithFilter - error"
          );
          return Promise.reject(error);
        }
      );
    },
    downloadNachaFile({ commit }, { fileDataId, loanPaymentId }) {
      return LoanPaymentService.downloadNachaFile(
        fileDataId,
        loanPaymentId
      ).then(
        (resp) => {
          commit(
            "dummyConsole",
            "LoanPaymentService.downloadNachaFile - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "dummyConsole",
            "LoanPaymentService.downloadNachaFile - error"
          );
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
